import React from "react";

const PaymentReport = () => {
  return <div>paymentReport</div>;
};

export default PaymentReport;
